import React, { useContext, useEffect } from "react";
import "./style.css";
import { CrossIcon } from "../../../GlobalIcons";
import { filterDataContext } from "../../../../App";

const BottomSheetTab = ({
  item,
  handleMobileSortTab,
  currentSortingTab,
  filteredParams,
  searchParams,
  setSearchParams,
  crossIcon,
}) => {
  const { setMinPriceInput, setMaxPriceInput, setTicketAvailabiltyInput } =
    useContext(filterDataContext);

  const RemoveParam = (Key) => {
    if (Key === "date_start" || Key === "date_stop") {
      searchParams.delete("date_start");
      searchParams.delete("date_stop");
    } else if (Key === "minPrice" || Key === "maxPrice") {
      searchParams.delete("minPrice");
      setMinPriceInput("");
      searchParams.delete("maxPrice");
      setMaxPriceInput("");
    } else if (Key === "ticket_Availability") {
      searchParams.delete("ticket_Availability");
      setTicketAvailabiltyInput("");
    } else {
      searchParams.delete(Key);
    }
    setSearchParams(searchParams);
  };

  return (
    <div
      className={`categary_tabs_mobile ${
        currentSortingTab === item.CategoryName ? "active" : ""
      }`}
      onClick={() => {
        handleMobileSortTab(item.CategoryName);
      }}
    >
      <div>{item.Icon}</div>
      <p
        style={{
          color: currentSortingTab === item.CategoryName && "#e8c433",
        }}
      >
        {item.CategoryName}
      </p>
      {crossIcon?.length > 0 === true && (
        <div
          className="chipCross_icon"
          onClick={() => {
            RemoveParam(crossIcon[0].key);
          }}
        >
          <CrossIcon />
        </div>
      )}
    </div>
  );
};

export default BottomSheetTab;
